var y = Object.defineProperty;
var f = Object.getOwnPropertySymbols;
var v = Object.prototype.hasOwnProperty, g = Object.prototype.propertyIsEnumerable;
var l = (e, n, t) => n in e ? y(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, d = (e, n) => {
  for (var t in n || (n = {}))
    v.call(n, t) && l(e, t, n[t]);
  if (f)
    for (var t of f(n))
      g.call(n, t) && l(e, t, n[t]);
  return e;
};
import { useRef as m, useCallback as w, useEffect as A, cloneElement as h } from "react";
import { u as F } from "./use-reduced-motion-C9DbPZfj.js";
import { jsx as I } from "react/jsx-runtime";
import { i as x } from "./is-element-C00Aie10.js";
import { V as R } from "./VisuallyHidden-BdfWO2mJ.js";
import { u as k } from "./use-merged-ref-n551Tfbr.js";
function P({ opened: e, shouldReturnFocus: n = !0 }) {
  const t = m(null), i = () => {
    var r;
    t.current && "focus" in t.current && typeof t.current.focus == "function" && ((r = t.current) == null || r.focus({ preventScroll: !0 }));
  };
  return F(() => {
    let r = -1;
    const o = (u) => {
      u.key === "Tab" && window.clearTimeout(r);
    };
    return document.addEventListener("keydown", o), e ? t.current = document.activeElement : n && (r = window.setTimeout(i, 10)), () => {
      window.clearTimeout(r), document.removeEventListener("keydown", o);
    };
  }, [e, n]), i;
}
const D = /input|select|textarea|button|object/, b = "a, input, select, textarea, button, object, [tabindex]";
function L(e) {
  return process.env.NODE_ENV === "test" ? !1 : e.style.display === "none";
}
function S(e) {
  if (e.getAttribute("aria-hidden") || e.getAttribute("hidden") || e.getAttribute("type") === "hidden")
    return !1;
  let t = e;
  for (; t && !(t === document.body || t.nodeType === 11); ) {
    if (L(t))
      return !1;
    t = t.parentNode;
  }
  return !0;
}
function p(e) {
  let n = e.getAttribute("tabindex");
  return n === null && (n = void 0), parseInt(n, 10);
}
function s(e) {
  const n = e.nodeName.toLowerCase(), t = !Number.isNaN(p(e));
  return /* @ts-expect-error function accepts any html element but if it is a button, it should not be disabled to trigger the condition */ (D.test(n) && !e.disabled || e instanceof HTMLAnchorElement && e.href || t) && S(e);
}
function N(e) {
  const n = p(e);
  return (Number.isNaN(n) || n >= 0) && s(e);
}
function O(e) {
  return Array.from(e.querySelectorAll(b)).filter(N);
}
function V(e, n) {
  const t = O(e);
  if (!t.length) {
    n.preventDefault();
    return;
  }
  const i = t[n.shiftKey ? 0 : t.length - 1], r = e.getRootNode();
  let o = i === r.activeElement || e === r.activeElement;
  const u = r.activeElement;
  if (u.tagName === "INPUT" && u.getAttribute("type") === "radio" && (o = t.filter(
    (c) => c.getAttribute("type") === "radio" && c.getAttribute("name") === u.getAttribute("name")
  ).includes(i)), !o)
    return;
  n.preventDefault();
  const a = t[n.shiftKey ? t.length - 1 : 0];
  a && a.focus();
}
function _(e = !0) {
  const n = m(null), t = (r) => {
    let o = r.querySelector("[data-autofocus]");
    if (!o) {
      const u = Array.from(r.querySelectorAll(b));
      o = u.find(N) || u.find(s) || null, !o && s(r) && (o = r);
    }
    o ? o.focus({ preventScroll: !0 }) : process.env.NODE_ENV === "development" && console.warn(
      "[@mantine/hooks/use-focus-trap] Failed to find focusable element within provided node",
      r
    );
  }, i = w(
    (r) => {
      e && r !== null && n.current !== r && (r ? (setTimeout(() => {
        r.getRootNode() ? t(r) : process.env.NODE_ENV === "development" && console.warn("[@mantine/hooks/use-focus-trap] Ref node is not part of the dom", r);
      }), n.current = r) : n.current = null);
    },
    [e]
  );
  return A(() => {
    if (!e)
      return;
    n.current && setTimeout(() => t(n.current));
    const r = (o) => {
      o.key === "Tab" && n.current && V(n.current, o);
    };
    return document.addEventListener("keydown", r), () => document.removeEventListener("keydown", r);
  }, [e]), i;
}
function E({
  children: e,
  active: n = !0,
  refProp: t = "ref",
  innerRef: i
}) {
  const r = _(n), o = k(r, i);
  return x(e) ? h(e, { [t]: o }) : e;
}
function T(e) {
  return /* @__PURE__ */ I(R, d({ tabIndex: -1, "data-autofocus": !0 }, e));
}
E.displayName = "@mantine/core/FocusTrap";
T.displayName = "@mantine/core/FocusTrapInitialFocus";
E.InitialFocus = T;
export {
  E as F,
  P as u
};
